/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_SendInputs */

const en_us2_coaching_chat_send = /** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const pt_br2_coaching_chat_send = /** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const pt_pt2_coaching_chat_send = /** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

/** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */
const es_419_coaching_chat_send = en_us2_coaching_chat_send;

/** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */
const fr_fr2_coaching_chat_send = en_us2_coaching_chat_send;

/** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */
const de_de2_coaching_chat_send = en_us2_coaching_chat_send;

/** @type {(inputs: Coaching_Chat_SendInputs) => LocalizedString} */
const it_it2_coaching_chat_send = en_us2_coaching_chat_send;

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Coaching_Chat_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_send = /** @type {((inputs?: Coaching_Chat_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_send(inputs)
	if (locale === "es-419") return es_419_coaching_chat_send(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_send(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_send(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_send(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_send(inputs)
	return en_us2_coaching_chat_send(inputs)
});
export { coaching_chat_send as "coaching.chat_send" }